import { createSlice } from "@reduxjs/toolkit";
import { addBulkData, addBulkResultData } from "./bulkRegistrationService";

const initialState = {
  addBulk: {
    isLotteryCreating: null,
    isLotteryCreated: null,
    lotteryCreationMsg: null,
  },
  addBulkResult: {
    isLotteryResultCreating: null,
    isLotteryResultCreated: null,
    lotteryResultCreationMsg: null,
  },
};

const bulkRegistrationSlice = createSlice({
  name: "bulkRegistration",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //Lottery creating
    builder
      .addCase(addBulkData.pending, (state) => {
        state.addBulk = {
          ...initialState.addBulk,
          isLotteryCreating: true,
          lotteryCreationMsg: "Loading",
        };
      })

      // REJECTED
      .addCase(addBulkData.rejected, (state, action) => {
        state.addBulk = {
          ...initialState.addBulk,
          isLotteryCreating: false,
          isLotteryCreated: false,
          lotteryCreationMsg:
            action.payload ||
            "Error occurred while creating the bulk registration.",
        };
      })

      // FULFILLED
      .addCase(addBulkData.fulfilled, (state, action) => {
        state.addBulk = {
          ...initialState.addBulk,
          isLotteryCreating: false,
          isLotteryCreated: true,
          lotteryCreationMsg:
            action.payload || "Successfully created the bulk registration.",
        };
      });

    builder
      .addCase(addBulkResultData.pending, (state) => {
        state.addBulkResult = {
          ...initialState.addBulkResult,
          isLotteryResultCreating: true,
          lotteryResultCreationMsg: "Loading",
        };
      })

      // REJECTED
      .addCase(addBulkResultData.rejected, (state, action) => {
        state.addBulkResult = {
          ...initialState.addBulkResult,
          isLotteryResultCreating: false,
          isLotteryResultCreated: false,
          lotteryResultCreationMsg:
            action.payload || "Error occurred while creating the bulk result.",
        };
      })

      // FULFILLED
      .addCase(addBulkResultData.fulfilled, (state, action) => {
        state.addBulkResult = {
          ...initialState.addBulkResult,
          isLotteryResultCreating: false,
          isLotteryResultCreated: true,
          lotteryResultCreationMsg:
            action.payload || "Successfully created the bulk result.",
        };
      });
  },
});

export default bulkRegistrationSlice.reducer;
